import { Lock } from "lucide-react";
import { EXPIRATION_LABELS } from "@/lib/format";

export function ExpirationSelector({ options, value, onChange, lockedOptions = [], onLockedClick }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2" role="radiogroup" aria-label="Expiration" data-testid="expiration-selector">
      {options.map((opt) => {
        const locked = lockedOptions.includes(opt);
        const active = value === opt;
        return (
          <button key={opt} type="button" role="radio" aria-checked={active} onClick={() => (locked ? onLockedClick?.(opt) : onChange(opt))}
            className={`pill flex items-center gap-1.5 ${active ? "pill-active" : "pill-inactive"} ${locked ? "opacity-70" : ""}`} data-testid={`expiration-${opt}`}>
            {locked && <Lock className="h-3 w-3" />}{EXPIRATION_LABELS[opt] || opt}
          </button>
        );
      })}
    </div>
  );
}
